export default __webpack_public_path__ + "static/media/four_of_cups.27093c72.png";